import { createFileRoute } from '@tanstack/react-router'

import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { ProjectsList } from '@/components/projects/projects-list'
import { parseProjectsSearch } from '@/components/projects/projects-search-schema'

export const Route = createFileRoute('/_app/projects/')({
  validateSearch: parseProjectsSearch,
  component: ProjectsPage,
})

function ProjectsPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className="space-y-6">
      <PageHeader title="Projets" documentTitle="Projets" />

      <Frame>
        <ProjectsList
          search={search}
          onSearchChange={(next) => {
            void navigate({ search: (current) => ({ ...current, ...next }) })
          }}
        />
      </Frame>
    </div>
  )
}
